import { ConsultationReport } from "~/providers/components";

export const OngoingPatientConsultationReport = () => {
  return <ConsultationReport />;
};
